import React, {useState, useEffect, useRef} from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import CandidateTab from './CandidateTab';
import NotificationPanels from './NotificationPanels';
import '../assets/css/candidate-tab-form.css';
import MainForm from "./ScotlandDisclosure/MainForm";
import { getScotDisc } from "../Actions/scotlandDisclosureActions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import GetMasterData from "../Helper/masterData";
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import _ from "lodash";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import ProgressHeading from './Common/ProgressHeading.jsx';

const CandidateScotlandDiscloser = ()=> {
  let { activeTab } = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [scotDisc, setScotDisc] = useState({});
  const { countryOptions } = GetMasterData();
  const [countries, setCountry] = useState({});
  const [check_name, setCheckName] = useState(true);
  const [unsavedScotlandData, setUnsavedScotlandData] = useState({});
  const form = useRef();
  const [role,setRole]=useState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(getScotDisc());
    };
    fetchData();
  }, []);

  const storeData = useSelector((state) => state.scotDisc);
  const { scotlandData, loading: getLoading } = storeData;
  useEffect(() => {
    if ( scotlandData && scotlandData.data && typeof scotlandData.data !== "undefined" && scotlandData.data !== null ) {
      if(Object.keys(unsavedScotlandData).length == 0){
        setScotDisc(scotlandData.data.data);
      }else{
        const uploadedDocuments =   _.cloneDeep(scotlandData.data.data.checksDetails[0].uploaded_documents);
        const unsavedDocumets = _.cloneDeep(unsavedScotlandData.checksDetails[0].uploaded_documents);
        if (uploadedDocuments ) {
          const newData = _.cloneDeep(unsavedScotlandData);
          newData.checksDetails[0].uploaded_documents = uploadedDocuments;
          setScotDisc(newData);
        } else {
          const newData = _.cloneDeep(unsavedScotlandData);
          newData.checksDetails[0].uploaded_documents = [];
          setScotDisc(newData);
        }
      }
    }
  }, [scotlandData, storeData]);

  useEffect(() => {
    if ( typeof getLoading !== "undefined" && getLoading !== null ) {
      if (getLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [scotlandData]);

  useEffect(() => {
    if ( scotlandData && scotlandData.data && typeof scotlandData.data !== "undefined" && scotlandData.data !== null ) {
      let check_name = scotlandData.data.data.checksDetails[0].IB_CHECK_NAME;
      setCheckName(check_name);
    }
  }, [scotlandData]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    let obj = {};
    for (var i in countryOptions) {
      obj[countryOptions[i].label] = countryOptions[i].label;
    }
    setCountry(obj);
  }, [countryOptions]);

  const reRenderAgain = (scotData) => {
    setUnsavedScotlandData(scotData);
    dispatch(getScotDisc());
  };

    return (
      <>
      <NotificationPanels/>
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header/>
      <Sidebar/> */}

      <section className="main-section candidate-tab-form" style={{paddingTop: '60px'}}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto w-100-mbl bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Scotland Disclosure"}/>
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}
              <form className="p-3 form2 form-section" style={{minHeight: '700px'}}>
                  <StepCount activeTab={"Scotland Disclosure"}/>
                  <div className="d-flex justify-content-between align-items-center flex-column-mbl flex-start-mbl">
                    <div>
                      <h2 className="fnt-smi-bld">{"Scotland Disclosure"}</h2>
                    </div>
                  </div>
                  <hr/>
                  <MainForm
                    isLoading={isLoading}
                    scotDisc={scotDisc}
                    reRenderAgain={reRenderAgain}
                    active={activeTab}
                    setIsLoading={(isLoading) => setIsLoading(isLoading)}
                    countries={countries}
                  />
              {/*Form*/}
              </form>
              <Footer />
            </div>
          </div>
        </div>
      </section>

      </>
    );
}
export default CandidateScotlandDiscloser;